import React, { Component } from 'react';
import { Button } from 'antd';
import styles from '../Administration.module.css';

class LicenceActiveComponent extends Component {
  render() {
    const { activeRecord } = this.props;
    const activeItemRows = [
      {
        label: 'License',
        value: activeRecord.licenseName,
      },
      {
        label: 'Type',
        value: activeRecord.licenseType
          ? activeRecord.licenseType
          : 'Full Access',
      },
      {
        label: 'Status',
        value: activeRecord.licenseIsActive ? 'ACTIVE' : 'INACTIVE',
      },
      {
        label: 'Activated On',
        value: new Date(activeRecord.licenseActivatedDate),
      },
      {
        label: 'Expiry Date',
        value: new Date(activeRecord.licenseExpiryDate),
      },
    ];
    return (
      <div
        className={styles.activeContentWrapper}
        style={
          activeRecord && activeRecord.licenseId
            ? {
                alignItems: 'flex-start',
              }
            : {
                alignItems: 'center',
                height: '100%',
              }
        }
      >
        {activeRecord && activeRecord.licenseId ? (
          activeItemRows.map((item, index) => (
            <div
              className={styles['active-item-container']}
              key={`${index}-active-item-container`}
            >
              <div className={styles['active-item-leftside']}>
                {item.label && (
                  <span
                    className={styles['active-item-label']}
                    style={{
                      marginBottom: '3px',
                    }}
                  >
                    {item.label}
                  </span>
                )}
                {item.type === 'array'
                  ? item.value &&
                    item.value.map((item) => (
                      <span className={styles['active-item-label']}>
                        {`- ${item}`}
                      </span>
                    ))
                  : item.value && (
                      <span className={styles['active-item-value']}>
                        {typeof item.value === 'string'
                          ? item.value
                          : `${item.value.getDate()} - ${
                              item.value.getMonth() + 1
                            } - ${item.value.getFullYear()}`}
                      </span>
                    )}
              </div>
              {item.actionFunction && (
                <div className={styles['active-item-rightside']}>
                  <Button
                    onClick={item.actionFunction}
                    className={styles.actionButton}
                  >
                    {item.actionText}
                  </Button>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={styles.noImagePreview}>
            <span className={styles.noPreviewText}>There is no data</span>
          </div>
        )}
      </div>
    );
  }
}

export default LicenceActiveComponent;
